import { render } from "./ReceiverCheckoutSingle.vue?vue&type=template&id=8da3ad98&scoped=true"
import script from "./ReceiverCheckoutSingle.vue?vue&type=script&lang=js"
export * from "./ReceiverCheckoutSingle.vue?vue&type=script&lang=js"

import "./ReceiverCheckoutSingle.vue?vue&type=style&index=0&id=8da3ad98&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da3ad98"]])

export default __exports__